{
  "R": [11, 59, 55, 222],
  "G": [4, 45, 165, 245],
  "B": [5, 91, 172, 229],
  "A": [0, 23, 70, 107],
  "I": [0, 56, 167, 255]
}
